export default __webpack_public_path__ + "static/media/today-special.6d9ddbc4.jpg";